export const COOKIES = {
    BEARER_AUTH : 'Bearer_auth'
};
